import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/mobile-menu/categories/137-outlet.svg")